module.exports = __webpack_public_path__ + "462a5bbbd7671de22e48eb51fe314319.fbx";